export const QuadernoTestPublicKey = 'pk_test_xxRaJy9aNCcHGFfhtGYP';
